// eslint-disable-next-line no-use-before-define
import React, { useState, useEffect } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Paper, Tabs, Tab } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Header, CompensationSearchControls } from "../common";
import { generateCompensationPeriods } from "../../utils/compensation/compensation";
import PharmaCompanyPeriodRow from "./pharmaCompanyPeriodRow";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: "1rem",
  },
  tabContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  tabs: {
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(0),
  },
  tab: {
    ...theme.typography.h6,
    color: theme.palette.text.hint,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.07rem",
  },
  actionContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: "red",
    ...theme.typography.body1,
  },
}));

const TabType = Object.freeze({
  Pharmacies: 0,
  Products: 1,
});

function PharmaCompany() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(TabType.Pharmacies);
  const [periods, setPeriods] = useState([]);
  const [currentYear, setCurrentYear] = useState(moment().year().toString());
  const {
    compensationsMap,
    filteredCompensationsMap,
    filteredCompensationCount,
    fetchError,
    fetchingMap,
    searching,
    searchError,
  } = useSelector(state => state.compensation);
  const { userData } = useSelector(state => state.user);

  useEffect(() => {
    // set periods
    setPeriods(generateCompensationPeriods(currentYear).reverse());
  }, [currentYear, setPeriods]);

  // eslint-disable-next-line react/no-unstable-nested-components
  function ContentTabs() {
    const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
    };

    return (
      <div className={classes.tabContainer}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="secondary"
        >
          <Tab
            className={classes.tab}
            label={t("pharmacies").toUpperCase()}
            value={TabType.Pharmacies}
          />
          <Tab
            className={classes.tab}
            label={t("products").toUpperCase()}
            value={TabType.Products}
          />
        </Tabs>
      </div>
    );
  }

  return (
    <Paper className={classes.root}>
      <Header showButton />
      <ContentTabs />
      <CompensationSearchControls
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        periods={periods}
        filteredCompensationsMap={filteredCompensationsMap}
        filteredCompensationCount={filteredCompensationCount}
        searching={searching}
        searchError={searchError}
        profitCenters={userData.profitCenters}
      />
      <div>
        {periods.map((period, index) => {
          // get compensations based on mode
          let compensations = null;
          if (filteredCompensationsMap != null) {
            compensations = filteredCompensationsMap.get(period.key) || [];
          } else {
            compensations = compensationsMap.get(period.key);
          }

          return (
            <PharmaCompanyPeriodRow
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              preload={index < 6}
              period={period}
              productMode={tabValue === TabType.Products}
              compensations={compensations}
              fetchError={fetchError}
              fetching={fetchingMap.get(period.key) != null}
            />
          );
        })}
      </div>
    </Paper>
  );
}

export default PharmaCompany;
